import React, { useCallback, useMemo, useState } from 'react'
import * as Icons from 'react-feather'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import EmailMessage from '../../shared/email-message/EmailMessage'
import { buildLoanApplicationPdfUrl } from '../finance-register/utils/loanApplicationPdfApi'
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'
import { logAuditEvent } from '../../utils/auditLogger'

function LoanApplicatgionFromGrid({ rows = [], isLoading = false, onRefresh = () => {}, moduleName = 'Loan Application Form' }) {
  const [filterText, setFilterText] = useState('')
  const [alert, setAlert] = useState(null)
  const [emailOpen, setEmailOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)

  const filtered = useMemo(() => {
    const term = (filterText || '').toLowerCase()
    if (!term) return rows
    return (rows || []).filter((r) => {
      return (
        (r.SalesNumber || '').toLowerCase().includes(term) ||
        (r.CustomerName || '').toLowerCase().includes(term) ||
        (r.LoanApplicationNo || '').toLowerCase().includes(term) ||
        (r.Status || '').toLowerCase().includes(term)
      )
    })
  }, [rows, filterText])

  const handleDownload = useCallback((row) => {
    try {
      logAuditEvent(moduleName, 'Download Button Click', JSON.stringify({ FinanceRegisterId: row?.FinanceRegisterId, CustomerName: row?.CustomerName }))
      const pdfUrl = buildLoanApplicationPdfUrl(row?.FinanceRegisterId)
      if (!pdfUrl) {
        CreateAlert('Missing finance register id', 'Error', setAlert)
        return
      }
      window.open(pdfUrl, '_blank')
    } catch (error) {
      console.error(error)
      CreateAlert('Unable to open PDF', 'Error', setAlert)
    }
  }, [moduleName])

  const handleEmail = useCallback((row) => {
    logAuditEvent(moduleName, 'Email Button Click', JSON.stringify({ FinanceRegisterId: row?.FinanceRegisterId, CustomerName: row?.CustomerName }))
    setSelectedRow(row)
    setEmailOpen(true)
  }, [moduleName])

  const columns = useMemo(() => [
    {
      name: 'Sales #',
      selector: (row) => row.SalesNumber || '-',
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: 'Customer Name',
      selector: (row) => row.CustomerName || '-',
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: 'Loan Application No',
      selector: (row) => row.LoanApplicationNo || '-',
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: 'Status',
      selector: (row) => row.Status || '-',
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: 'Created Date',
      selector: (row) => row.CreatedDate || '',
      cell: (row) => (row.CreatedDate ? moment(row.CreatedDate).format('DD/MM/YYYY') : '-'),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: 'Actions',
      width: '130px',
      cell: (row) => (
        <div className="edit-delete-action">
          <Link className="me-2 p-2" to="" onClick={() => handleDownload(row)} title="Download / View">
            <Icons.Download size={16} />
          </Link>
          <Link className="me-2 p-2" to="" onClick={() => handleEmail(row)} title="Send Email">
            <Icons.Mail size={16} />
          </Link>
        </div>
      )
    }
  ], [handleDownload, handleEmail])

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>

          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={filtered}
            progressPending={isLoading}
            persistTableHead
            pagination
            defaultSortFieldId={1}
            sortIcon={<SortArrow />}
          />
        </div>
      </div>

      <Modal show={emailOpen} onHide={() => setEmailOpen(false)} backdrop="static" dialogClassName="add-centered-sales-modal">
        <div className="modal-header border-0 custom-modal-header">
          <h5 className="modal-title">Email - Loan Application Form</h5>
          <button type="button" className="close" aria-label="Close" onClick={() => setEmailOpen(false)}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <EmailMessage
            FinanceRegisterData={selectedRow}
            onCancel={() => setEmailOpen(false)}
            onSent={() => {
              setEmailOpen(false)
              onRefresh()
            }}
            moduleName={moduleName}
          />
        </div>
      </Modal>
    </>
  )
}

export default LoanApplicatgionFromGrid
